import type { AnalyticsFeatures } from '../../services/analytics';
import { formatInt } from './format';
import { flagAvailability, flagCount, flagPayers } from './featuresCards';
import { InfoTip } from './InfoTip';
import { METRIC_INFO } from './metricInfo';
import styles from './FeatureFlags.module.css';

interface FeatureFlagsProps {
    flags: AnalyticsFeatures['featureFlags'];
}

export function FeatureFlags({ flags }: FeatureFlagsProps) {
    const { base, items } = flags;
    return (
        <section className={styles.card}>
            <header className={styles.header}>
                <h4 className={styles.title}>
                    Feature flags na base
                    <InfoTip info={METRIC_INFO.featureFlags} label="Feature flags na base" align="start" />
                </h4>
                <span className={styles.hint}>
                    {formatInt(base)} {base === 1 ? 'conta' : 'contas'} no filtro
                </span>
            </header>

            {items.length === 0 ? (
                <p className={styles.empty}>Nenhuma funcionalidade cadastrada.</p>
            ) : (
                <ul className={styles.list}>
                    {items.map((f) => (
                        <li key={f.key} className={styles.row}>
                            <div className={styles.name}>
                                <span className={styles.label}>{f.label}</span>
                                <span className={styles.sub}>{flagAvailability(f, base)}</span>
                            </div>
                            <div
                                className={styles.track}
                                role="progressbar"
                                aria-label={f.label}
                                aria-valuemin={0}
                                aria-valuemax={100}
                                aria-valuenow={f.pct ?? 0}
                            >
                                <div className={styles.fill} style={{ width: `${Math.min(Math.max(f.pct ?? 0, 0), 100)}%` }} />
                            </div>
                            <div className={styles.count}>
                                <span className={styles.label}>{flagCount(f, base)}</span>
                                <span className={styles.sub}>{flagPayers(f)}</span>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </section>
    );
}
